import { Chip } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

export function FreeForMembersChip() {
  const { t } = useTranslation("client\\components\\Chips\\FreeForMembersChip");
  return (
    <Chip
      label={t`Free for members`}
      size="small"
      sx={theme => ({
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.warning.main
      })}
    />
  );
}
